
import { Benefit } from "@/models/Order";
import { defineComponent, ref } from "vue";

export default defineComponent({
    props: {
        benefit: {
            type: Benefit,
            required: true
        }
    },
    async setup(props, { emit }) {
        const showCodes = ref(false);
        return { showCodes };
    },
});
